import Mainrouter from './Components/MainRouter';
import './App.css';

function App() {
  return <Mainrouter />;
}

export default App;
